module.exports = __webpack_public_path__ + "img/yidian.474a4c6e.png";